import { render } from "./object-explorer.vue?vue&type=template&id=0836362f&scoped=true"
import script from "./object-explorer.vue?vue&type=script&lang=js"
export * from "./object-explorer.vue?vue&type=script&lang=js"

import "./object-explorer.vue?vue&type=style&index=0&id=0836362f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0836362f"]])

export default __exports__